<div class="form-group">
    <mat-checkbox [disabled]="this.disabled" [(ngModel)]="this.value"  (click)="onClick($event)">{{this.label}}</mat-checkbox>
</div>